import z from "zod";

export const stringOperatorSchema = z
  .object({
    startsWith: z.string(),
    endsWith: z.string(),
    contains: z.string(),
    equals: z.string(),
  })
  .partial();

export const numberOperatorSchema = z
  .object({
    lte: z.coerce.number(),
    lt: z.coerce.number(),
    gte: z.coerce.number(),
    gt: z.coerce.number(),
    equals: z.coerce.number(),
  })
  .partial();

export const dateOperatorSchema = z
  .object({
    lte: z.coerce.date(),
    lt: z.coerce.date(),
    gte: z.coerce.date(),
    gt: z.coerce.date(),
    equals: z.coerce.date().optional(),
  })
  .partial();
export const booleanOperatorSchema = z
  .object({
    equals: z.preprocess((val) => {
      if (val === "true" || val == 1) {
        return true;
      }
      if (val === "false" || val == 0) {
        return false;
      }
      return true;
    }, z.coerce.boolean()),
  })
  .partial();
